module.exports = __webpack_public_path__ + "img/voice.17e08fb5.svg";